import { Component } from '@angular/core';
import { ActionIconsComponent } from '../../../components/action-icons/action-icons.component';
import { DemoAndProofsComponent as SharedDemoAndProofsComponent } from '../../../components/demo-and-proofs/demo-and-proofs.component';

@Component({
  selector: 'app-space-demo-and-proofs-page',
  standalone: true,
  imports: [SharedDemoAndProofsComponent, ActionIconsComponent],
  templateUrl: './demo-and-proofs.component.html',
  styleUrl: './demo-and-proofs.component.scss'
})
export class SpaceDemoAndProofsComponent {}
